<script>
  import CustomButton from "../Inputs/ButtonWithIcon.vue";
  import Place from "../Place.vue";
  import ButtonWithIcon from "../Inputs/ButtonWithIcon.vue";
  import { EventBus } from '@/eventBus'

  export default {
    name: "TablePlaces",
    components: { Place, ButtonWithIcon },
    props: ['placeList', 'location'],
    data() {
      return {
        cell_width: 0,
        cell_height: 0
      }
    },
    computed: {

      getListX() {
        return [...Array(this.getSizeX).keys()].map(i => i)
      },
      getListY() {
        return [...Array(this.getSizeY).keys()].map(i => i)
      },
      getSizeX() {
        return parseInt(this.location.size_x)
      },
      getSizeY() {
        return parseInt(this.location.size_y)
      }
    },
    methods: {
      getPlaceByXAndY(x, y) {
        return this.placeList.filter((place) => place.topPos == y && place.leftPos == x)
      },
      onClick(place) {
        this.$emit('select-table', place)
      },

      showPopupCalendar() {
        this.$emit('show-mobile-calendar')
      },

    },
  }
</script>

<template>
  <div class="tables" :style="'--width:' + (100 / this.getSizeX) + '%; --height: ' + (100 / this.getSizeY) + '%'">
    <div class="button-mobile-date" @click="showPopupCalendar"> Дата </div>
    <div v-for="y in getListY" class="inserted_height table-row">
      <div v-for="x in getListX" class="wrapper">
        <place v-for="place in getPlaceByXAndY(x, y)" :key="place.id" :place="place" :cell_width="cell_width"
          :cell_height="cell_height" :name="place.name" @click="onClick(place)">
        </place>
      </div>
    </div>

  </div>
</template>

<style scoped>
.tables {
  width: 100%;
  height: 100%;
  padding: 24px 24px 90px;
  box-sizing: border-box;
}




.table-row {
  display: flex;
  width: 100%;
  flex-wrap: nowrap;
}

.wrapper {
  width: var(--width);
  height: 100%;
}

.wrapper svg {
  max-height: var(--height);
  max-width: var(--width);
}

.inserted_height {
  height: var(--height);
}

.button-mobile-date {
  padding: 12px 38px;
  border-radius: 8px;
  background-color: var(--beel-primary);
  color: #FFFFFF;
  display: none;
  position: absolute;
  left: 70px;
  top: 10px;
  transform: translate3d(-50%, 0, 0);
  cursor: pointer;
  transition: .4s;
  white-space: nowrap;
  user-select: none;
}

.button-mobile-date:hover {
  background-color: var(--beel-smooth);
}

@media (max-width: 1050px) {


  .tables {
    position: relative;
    padding: 100px 16px 0;
  }

  .button-mobile-date {
    display: flex;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/client/Places/TablePlaces.vue